export default [
  {
    path: "/kys-hedefler",
    name: "kys-hedefler",
    component: () => import("@/views/kys-hedefler/HedeflerListesi.vue"),
    meta: { public: false, title: "kys_hedefler.hedefler", yetki: { k: [1190602] } },
  },
]
